import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';
export const pushVerificationPopup = (actionType)=>pushModal(ModalType.VERIFICATION, {
        params: {
            actionType
        },
        wrapInModal: false
    });
